import React from "react";

import DataEntry from "./portfolioEntryWizard/Main";

import Instructions from "./portfolioEntryWizard/components/Instructions";
import Home from "./home/HomePage";
import ShoppingCart from "./shoppingCart/Main";
import Account from "./account/Main";
import Portfolio from "./portfolio/Main";

import SignOut from "./home/components/SignOutPage";
import Admin from "./admin/Main";
// import Test from './testing/logos';
// import TestChart from './testing/Chart';
import TermsOfUse from "./home/components/TermsOfUse";
import Contact from "./home/components/ContactUs";
import AboutUs from "./home/components/AboutUs";

import ForgotPassword from "./account/ForgotPassword";
import PasswordReset from "./account/PasswordReset";

import ConfirmBox from "./components/confirmBox/ConfirmBox";

import { MuiPickersUtilsProvider } from "@material-ui/pickers";

import DateFnsUtils from "@date-io/moment";
import { hashHistory } from "./browserHistory";

import { Router, Switch, Route, Redirect } from "react-router-dom";
import BlogListing from "blog/BlogListing";
import Blog1 from "blog/blogPosts/3-6-2021";
import Blog2 from "blog/blogPosts/3-7-2021";

export default () => (
  // <MuiPickersUtilsProvider utils={DateFnsUtils}>
  <div>
    <ConfirmBox />
    <Router history={hashHistory}>
      <Switch>
        <Route path="/Home" component={Home} />
        <Route path="/DataEntry/Instructions" component={Instructions} />

        <Route path="/DataEntry/:mode?/:id?" component={DataEntry} />
        <Route
          path="/DataEntry2/:mode?/:id?/:regenerate?"
          component={DataEntry}
        />

        <Route path="/ShoppingCart/:sessionId?" component={ShoppingCart} />
        {/* <Route path="/DataEntryOld" component={DataEntryOld} /> */}
        <Route path="/Account/Signout" component={SignOut} />
        <Route path="/Account/:mode?/:id?" component={Account} />
        <Route path="/Portfolio/:id?/:regenerate?" component={Portfolio} />

        <Route path="/ForgotPassword" component={ForgotPassword} />
        <Route path="/PasswordReset/:id" component={PasswordReset} />
        <Route path="/Admin/:mode?/:id?" component={Admin} />
        {/* <Route path="/logos" component={Test} /> */}
        {/* <Route path="/chartTest" component={TestChart} /> */}
        <Route path="/TermsOfUse" component={TermsOfUse} />
        <Route path="/Contact" component={Contact} />
        <Route path="/AboutUs" component={AboutUs} />

        <Route path="/Blog/1" component={Blog1} />
        <Route path="/Blog/2" component={Blog2} />
        <Route path="/Blog" component={BlogListing} />
        

        <Redirect exact from="*" to="/Home" />
      </Switch>
    </Router>
  </div>
  // </MuiPickersUtilsProvider>
);



// WEBPACK FOOTER //
// ./src/App.js